import { Button, Drawer, Grid, Stack } from "@mui/material";
import Title from "./Title";
import { useEffect, useState } from "react";
import { Card } from "./Card";
import { useServiceDrawer } from "../features/orders/useServiceDrawer";
import Amazon from "../../assests/Amazon-logo-meaning.jpg";
import Xpress from "../../assests/xpressLogo.avif";
import BlueDart from "../../assests/bluedartLogo.png";
import delhiveryLogo from "../../assests//delhiveryLogo.png";
import ekartlogo from "../../assests/ekartLogo.jpg";

import toast from "react-hot-toast";
import {
  assignOrder,
  bookOrderMethod,
  fetchRateRequest,
  getOrderDetails,
} from "../features/orders/orderApi";
import { StyledButton } from "./StyledButton";
import { IndvOrder } from "../features/orders/OrderDetails";
import { useNavigate, useSearchParams } from "react-router-dom";

interface dataType {
  id: number;
  error: boolean;
  quote_id: number;
  delivery_by: string;
  mode: string;
  cod_charge: number;
  amount: number;
  service: string;
  name?: any;
}

const RateOrderAssignDrawer = () => {
  const [data, setData] = useState<dataType[]>([]);

  const [orderData, setOrderData] = useState<IndvOrder>();

  const [isLoading, setIsLoading] = useState(false);

  const { id, isOpen, onOpenSchedule, onClose } = useServiceDrawer();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);

      getOrderDetails(id as string)
        .then((data) => {
          setOrderData(data.data?.data?.order_detail);
          fetchRateRequest(id)
            .then((data) => {
              if (data?.data?.data.length === 0) {
                setIsLoading(false);
                return toast.error("No Service Found");
              }

              if (data.data?.status === "success") {
                let finalData = data?.data?.data;
                finalData.map((el: any) => (el.id = el.quote_id));
                setData(finalData);
                setIsLoading(false);
              }
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        })
        .catch((err) => {
          toast.error("Order with that id doesn't exist!");
        });
    } else {
      setData([]);
      setIsLoading(false);
    }
  }, [isOpen, id]);

  const assignOrderHandler = (quoteId: number) => {
    assignOrder({
      id,
      quote_id: quoteId,
    })
      .then((data) => {
        bookOrderMethod([`${id}`])
          .then((data) => {
            toast.success("Order Booked successfully!");
            searchParams.set("orderId", `${id}`);
            setSearchParams(searchParams);
            onOpenSchedule(id);
            onClose();
          })
          .catch((err) => {
            toast.error("Try again later!");
          });
      })
      .catch((err) => console.log(err));
  };

  const WhichImage = (service: string) => {
    if (service?.includes("xpressbees")) return Xpress;
    if (service?.includes("amazon")) return Amazon;
    if (service?.includes("delhivery")) return delhiveryLogo;
    if (service?.includes("bluedart")) return BlueDart;
    if (service?.includes("ekart")) return ekartlogo;
    if (service?.includes("DELHIVERYB2BC")) return delhiveryLogo;
    if (service?.includes("DELHIVERYB2B")) return delhiveryLogo;

    return "";
  };

  const navigate = useNavigate();

  const navigateToOrder = () => {
    onClose();
    return navigate(`order/details/${id}`);
  };

  return (
    <>
      <Drawer
        open={isOpen && !isLoading}
        onClose={() => onClose("")}
        anchor="right"
      >
        <div
          className="rate-order-assign"
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "45%",
              height: "100%",
              background: "#217aee",
              color: "#fff",
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
                rowGap: "30px",
              }}
            >
              <p
                style={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Order Details Order
              </p>
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                Pickup From <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  {orderData?.shipper_address_address}
                </span>
              </p>
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                Deliver To <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  {orderData?.receiver_address_address}
                </span>
              </p>
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                Value <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  Rs. {orderData?.invoice_value}
                </span>
              </p>
              {/* <p
                style={{
                  fontSize: "12px",
                }}
              >
                Payment Mode <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  COD
                </span>
              </p> */}

              <StyledButton
                onClick={navigateToOrder}
                variant="contained"
                sx={{
                  paddingX: "20px !important",
                  marginTop: "100px",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  ":hover": {
                    backgroundColor: "#ffffffd1",
                  },
                }}
              >
                <p
                  style={{
                    textTransform: "none",
                  }}
                >
                  View All Details
                </p>
              </StyledButton>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#f0f0f0",
              padding: "20px",
              color: "#000",
            }}
          >
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Stack
                  width={"100%"}
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Title title="Select Courier Partner" />

                  <Button onClick={() => onClose("")}>X</Button>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  gap={"40px"}
                  style={{
                    height: "calc(100vh - 200px)",
                    overflowY: "scroll",
                    paddingBottom: "40px",
                  }}
                >
                  {data &&
                    data?.map((row, index) => (
                      <Grid item md={3.5} key={index}>
                        <Card>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              gap: "20px",
                              marginBottom: "40px",
                            }}
                          >
                            <div
                              style={{
                                background: "#fff",
                                height: "60px",
                                width: "60px",
                                borderRadius: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {WhichImage(
                                row?.service ? row?.service : row?.name
                              ) !== "" && (
                                <img
                                  style={{
                                    width: "80%",
                                    objectFit: "contain",
                                    objectPosition: "center",
                                    mixBlendMode: "multiply",
                                  }}
                                  src={WhichImage(
                                    row?.service ? row?.service : row?.name
                                  )}
                                />
                              )}
                            </div>
                            <div>
                              <p>{row?.service ? row?.service : row?.name}</p>
                              <p>Rating 4.7</p>
                            </div>
                          </div>
                          <div
                            style={{
                              background: "#f0f0f0",
                              padding: "20px",
                              borderRadius: "10px",
                            }}
                          >
                            <p>Estimated Delivery: {row?.delivery_by}</p>
                            <p>Charges: Rs. {row?.amount}</p>

                            <StyledButton
                              fullWidth
                              variant="contained"
                              sx={{
                                textTransform: "none",
                                marginTop: "100px",
                                backgroundColor: "#fff !important",
                                color: "#000",
                                borderRadius: "10px",
                                ":hover": {
                                  backgroundColor: "#ffffffd1 !important",
                                },
                              }}
                              onClick={() => assignOrderHandler(row.quote_id)}
                            >
                              Ship Now
                            </StyledButton>
                          </div>
                        </Card>
                      </Grid>
                    ))}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default RateOrderAssignDrawer;
